import React from 'react';
import loader from "../../assets/images/loader.gif";


class Loader extends React.Component{
    render(){
        return(
            <div className="loader"><img src={loader} /></div>
        );
    }
}

export default Loader;
